import { Route, Routes } from "react-router-dom"
import { UIBuilder } from "./pages/ui-builder"

export const Router = () => {
  return null
  return (
    <Routes>
      <Route path=":id" element={<UIBuilder />} />
    </Routes>
  )
}
